module.exports = __webpack_public_path__ + "img/about.b1c8bf53.png";